import React from 'react';
import "../Components/navbar.css"
import {Link} from 'react-router-dom';
import {ShoppingCart} from 'phosphor-react';
function Navbar() {
  return (
      <div className="navbar">
        <img src="https://i.pinimg.com/originals/66/f7/72/66f77296282b5ab7c2780724802614c0.png" alt="" />
        <div className="links">
          <Link to="/"><li><a>Shop</a></li></Link>
          <li className='cart-img'><Link to="/cart"><ShoppingCart size={32}/></Link></li>
        </div>
      </div>
  );
}

export default Navbar;
